import { entry, entryById, entryBySlug, collectionList, taxonomyList, navigationTree, layout, statamicSearch, statamicRequest, setPreviewToken } from '~/pinkyellow/satanic-api';

// --

export default () => {
  return { entry, entryById, entryBySlug, collectionList, taxonomyList, navigationTree, layout, statamicSearch, statamicRequest, setPreviewToken };
};
